import { QuestionnaireAnswerTypeConnectionInput } from '@/models/gen/graphql';

import { QuestionnaireAnswerTypeConnectionDocument } from '@/api/queries';
import graphApi from '@/api';
import { queryInput } from '@/utils';

const [, runRefetchQuestionnaireAnswerType] = graphApi(QuestionnaireAnswerTypeConnectionDocument);
const PAGE_SIZE = 1000;

export const searchAnswerTypes = async () => {
  const input: QuestionnaireAnswerTypeConnectionInput = {
    first: PAGE_SIZE,
    after: null,
    query: [{ active: queryInput(1) }],
  };

  return await runRefetchQuestionnaireAnswerType({ input });
};

export const searchAnswerTypesWithMetadata = async () => {
  const res = await searchAnswerTypes();

  return {
    answerTypes: res?.searchQuestionnaireAnswerType?.questionnaireAnswerTypeConnection?.edges
      ?.map((edge) => edge?.node)
      .filter((node) => Boolean(node)),
    totalCount: res?.searchQuestionnaireAnswerType?.questionnaireAnswerTypeConnection?.totalCount,
  };
};
